import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Checkbox } from '@/components/ui/checkbox';
import { fmtMoeda } from '@/lib/utils/formatters';
import { useApuracaoSN } from '@/contexts';
import type { SegregacaoTot } from '@/services/SimplesNacional/Segregacao/api/types';

interface TotaisGeraisProps {
  tot: SegregacaoTot | undefined;
  action?: React.ReactNode;
}

export function TotaisGerais({ tot, action }: TotaisGeraisProps) {
  const { mostrarZeros, setMostrarZeros } = useApuracaoSN();

  const linhas = [
    { label: 'Total de Saídas', valor: tot?.Total_Saidas ?? 0 },
    { label: 'Total Cancelados', valor: tot?.Total_Cancelados ?? 0 },
    { label: 'Faturamento', valor: tot?.Total_Faturamento ?? 0 },
    { label: 'Receita Segregada', valor: tot?.Total_Segregado ?? 0 },
    { label: 'Não Segregado', valor: tot?.Total_NaoSegregado ?? 0 },
    { label: 'Não Gerador de Receita', valor: tot?.Total_NaoGeradorReceita ?? 0 },
    { label: 'Em Revisão', valor: tot?.Total_EmRevisao ?? 0 },
  ];

  const linhasFiltradas = mostrarZeros ? linhas : linhas.filter(l => l.valor !== 0);

  return (
    <Card>
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between">
          <CardTitle className="text-sm font-semibold">Totais Gerais</CardTitle>
          <div className="flex items-center gap-3">
            {action}
            <label className="flex items-center gap-2 text-xs text-muted-foreground cursor-pointer">
              <Checkbox checked={mostrarZeros} onCheckedChange={v => setMostrarZeros(!!v)} />
              Mostrar valores zerados
            </label>
          </div>
        </div>
      </CardHeader>
      <CardContent className="p-0">
        <div className="divide-y">
          {linhasFiltradas.length === 0 ? (
            <p className="px-6 py-4 text-sm text-muted-foreground">Nenhum dado disponível.</p>
          ) : (
            linhasFiltradas.map(l => (
              <div key={l.label} className="flex justify-between px-6 py-3 text-sm">
                <span className="text-muted-foreground">{l.label}</span>
                <span className="font-medium tabular-nums">{fmtMoeda(l.valor)}</span>
              </div>
            ))
          )}
        </div>
      </CardContent>
    </Card>
  );
}
